import React, { useState, useEffect, useCallback } from "react";
import { Layout, Button, theme } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { EditOutlined } from "@ant-design/icons";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";
import AddSensorApiConfigurations from "../../common/Models/SensorApiConfigurations/AddSensorApiConfigurations";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const TimeApiConfigurations = () => {
  const { Content } = Layout;
  const navigate = useNavigate();
  const { useToken } = theme;
  const { token } = useToken();

  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getStorage = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        setRuntimeConfigs(response.payloadDto.filter(item => item?.environment === token?.environment && item?.tag === 'STORAGE_INSTRUCTION_CONFIG'));
        setTotalElements(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getStorage();
  }, [PageLoading, getStorage]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const paginatedData = RuntimeConfigs.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );


  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">

          <td className="pt-3" style={{ width: "15%" }}>
            {item?.configKey}
          </td>
          <td className="pt-3" style={{ width: "15%" }}>
            {item?.configValue}
          </td>


          <td style={{ width: "5%" }}>
            <div className="d-flex ">
              <Link
                to={`/settings/edit-configurations?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_RUNTIME_CONFIG'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>

            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">

        </tr>
      );
    }
  };


  const handleGoBack = () => {
    navigate(-1);
  };

  const [modalSensorApiVisible, setModalSensorApi] = useState(false);
  const handleOpenSensorApidModal = () => {

    setModalSensorApi(true);

  };
  const handlSensorApiCloseModal = () => {
    setModalSensorApi(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <Button
              onClick={handleGoBack}
              className="btn btn-primary btn-back"
            >
              Back
            </Button>

            <table className="table users-table pt-3">
              <thead>
                <tr>
                  <th>config Key</th>
                  <th>Config Value</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={pageSize}
            />
          )}
          </div>
        </Content>
        <AddSensorApiConfigurations
          visible={modalSensorApiVisible}
          onClose={handlSensorApiCloseModal}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default TimeApiConfigurations;
